import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { Switch, HashRouter, Route, Redirect } from 'react-router-dom';
import { composeWithDevTools } from '@redux-devtools/extension';
import thunk from 'redux-thunk';
import config from './config';
import NoMatch from './components/404';
import { ConfigProvider } from 'antd';
import esES from 'antd/lib/locale-provider/es_ES';
import './index.css';
import Login from './containers/login';
import * as serviceWorker from './serviceWorker';
import reducers from './reducers';
import Main from './containers/main';

/* Graficas */
import Test_chart from './components/test_charts/charts';

/* Meeting */
import MeetingComponent from './components/meeting/MeetingComponent';


const user = JSON.parse(localStorage.getItem('@@auth_user'));

const sessionChecker = ({ getState }) => {
	return (next) => (action) => {
		if (action.code !== undefined) {
			if (action.code === -19) {
				localStorage.removeItem('@@auth_user');
				window.location.reload();
			}
		}
		return next(action);
	};
};

const store = createStore(
	reducers,
	config.logger
		? composeWithDevTools(applyMiddleware(thunk, sessionChecker, require('redux-logger').logger))
		: applyMiddleware(thunk, sessionChecker)
);

function PrivateRoute({ children, ...rest }) {
	const user = JSON.parse(localStorage.getItem('@@auth_user'));
	return (
		<Route
			{...rest}
			render={({ location }) =>
				user ? (
					children
				) : (
						<Redirect exact
							to={{
								pathname: "/login",
								state: { from: location }
							}}
						/>
					)
			}
		/>
	);
}

ReactDOM.render(
	<ConfigProvider locale={esES}>
		<Provider store={store}>
			<HashRouter>
				<Switch>
					<Route exact path="/">
					    <Redirect exact to="/main" />
					</Route>
					<Route path="/login" component={Login} />
					<Route path="/test_chart" component={Test_chart} />
					<PrivateRoute path="/main" >
						<Main />
					</PrivateRoute>
					<Route component={NoMatch}/>
				</Switch>
			</HashRouter>
		</Provider>
	</ConfigProvider>,
	document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
